<template>
    <div class="modal fade" id="cardProfileListModal" tabindex="-1" aria-labelledby="cardProfileListModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header text-bg-primary">
                    <h5 class="modal-title" id="cardProfileListModalLabel">{{ $t('cardProfile.listTitle') }}</h5>
                    <button type="button" class="btn-close text-light" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="d-flex justify-content-end mb-2">
                        <button
                            type="button"
                            class="btn btn-sm btn-outline-primary"
                            :disabled="!canAdd"
                            data-bs-toggle="modal"
                            data-bs-target="#cardProfileModal"
                            @click="$emit('add')"
                        >
                            Ajouter un format
                        </button>
                    </div>

                    <table v-if="profiles.length > 0" class="table table-centered mb-0">
                        <thead>
                            <tr>
                                <th>{{ $t('cardProfile.format') }}</th>
                                <th class="table-action text-end">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(profile, index) in profiles" :key="`${profile.id}-${index}`">
                                <td>{{ profile.toString() }}</td>
                                <td class="table-action text-end">
                                    <a
                                        href="javascript:void(0);"
                                        class="text-secondary"
                                        data-bs-toggle="modal"
                                        data-bs-target="#cardProfileModal"
                                        @click="$emit('edit', profile)"
                                    >
                                        <i class="mdi mdi-pencil font-18"></i>
                                    </a>
                                    <a href="javascript:void(0);" class="text-secondary" @click="$emit('remove', profile)">
                                        <i class="mdi mdi-trash-can font-18"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div v-else class="empty-state">
                        Aucun format de badge
                    </div>
                </div>
                <div class="modal-footer justify-content-center">
                    <button type="button" class="btn btn-outline-secondary" style="min-width: 140px;" data-bs-dismiss="modal">{{ $t('cardProfile.close') }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CardProfileListModal',
    props: {
        profiles: {
            type: Array,
            default: () => [],
        },
        canAdd: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['add', 'edit', 'remove'],
};
</script>

<style scoped>
.empty-state {
    align-items: center;
    color: #6c757d;
    display: flex;
    justify-content: center;
    min-height: 90px;
}
</style>
